export default __webpack_public_path__ + "education_mfb227f.jpg";